import API from "libs/api";
import { createAuthInstance } from "libs/request";
// @ts-ignore
import config from "config/index";

class AuthAPI extends API {
  constructor(props?) {
    super(props);

    this.instance = this.createInstance(
      `${config.api.auth}`,
      createAuthInstance
    );
  }

  register(payload = {}) {
    return this.instance.post('/public/register', payload);
  }

  forgotPassword(email) {
    return this.instance.post(`/public/forgot-password/${email}`);
  }

  confirmOtp(publicKey, code) {
    return this.instance.post(`/public/confirm-otp/${publicKey}`, { code });
  }

  resetPassword(publicKey, payload = {}) {
    return this.instance.post(`/public/reset-password/${publicKey}`, payload);
  }
}

export default AuthAPI;
